import { Outlet,useNavigate  } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import { useState } from "react";
import { Menu,User } from "lucide-react";
import "./layout.css";
import { useEffect,useRef } from "react";
import { FaBell } from "react-icons/fa";
// import "../../Pages/Dashboard/dashboard.css";
import axios from "axios";
import toast from "react-hot-toast";

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const [hideTopIcons, setHideTopIcons] = useState(false);

const [unreadCount, setUnreadCount] = useState(0);
const lastAlarmTimeRef = useRef(0);

const API_URL = process.env.REACT_APP_API_DJANGO_URL;





const fetchAlarms = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    const res = await axios.get(
      `${API_URL}/api/get_alarms_notification/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const alarmList = res.data.data || [];
    const active = alarmList.filter((a) => !a.cleared);

    if (alarmList.length > 0) {
      const newestTime = alarmList[0].createdTime;

      if (
        lastAlarmTimeRef.current !== 0 &&
        newestTime > lastAlarmTimeRef.current
      ) {
        toast.error("🚨 New Alarm Triggered!");
        localStorage.removeItem("alarmsViewed");
      }

      lastAlarmTimeRef.current = newestTime;
    }

    setUnreadCount(
      localStorage.getItem("alarmsViewed") === "true"
        ? 0
        : active.length
    );
  } catch (err) {
    console.error("Alarm fetch error:", err);
  }
};

useEffect(() => {
  fetchAlarms();

  const interval = setInterval(() => {
    fetchAlarms();
  }, 30000);

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  let timeout;

  const handleScroll = () => {
    setHideTopIcons(true);

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setHideTopIcons(false); // show again after scroll stops
    }, 150);
  };

  const container = document.querySelector(".page-wrapper");

  container?.addEventListener("scroll", handleScroll);

  return () => container?.removeEventListener("scroll", handleScroll);
}, []);

//   return (
//     <div className="app-layout">

//       <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />

// <div
//   className="alarm-bell"
//   // className={`alarm-bell ${hideTopIcons ? "hide-icons" : ""}`}
//   onClick={() => {
//     localStorage.setItem("alarmsViewed", "true");
//     setUnreadCount(0);
//     navigate("/alarms-notification");
//   }}
// >
//   <FaBell size={25} />

//   {unreadCount > 0 && (
//     <span className="alarm-badge">
//       {unreadCount}
//     </span>
//   )}
// </div>
      

//    <div 
//   className="profile-icon"
//   // className={`profile-icon ${hideTopIcons ? "hide-icons" : ""}`}
//     onClick={() => navigate("/profile")}>
//   <User size={24} />
// </div>

//       {/* MENU BUTTON OUTSIDE SIDEBAR */}
//       <div
//         className="collapse-icon"
//         onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
//       >
//         <Menu size={24} />
//       </div>

//       <div className={`main-content ${sidebarCollapsed ? "collapsed" : ""}`}>
//         <div className="page-wrapper">
//     <Outlet />
     
//   </div>

//   <footer className="app-footer">
//     <p>© IgnisVigil 2026 Smart Fire Fighting Systems Monitoring Solution</p>
//   </footer>

//       </div>
//     </div>
//   );


return (
    <div className="app-layout">
      {/* Sidebar handles its own absolute positioning toggle internally */}
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />

      {/* Main App Workspace Area */}
      <div className={`main-content ${sidebarCollapsed ? "collapsed" : ""}`}>
        
        {/* Pinned Top Navbar */}
        <div className="top-navbar">
          {/* This empty spacer pushes the actions group all the way to the right */}
          <div className="navbar-spacer" />

          {/* Grouped Icons Container */}
          <div className="navbar-actions">
            {/* Alarm Notification Bell */}
            <div
              className="alarm-bell"
              onClick={() => {
                localStorage.setItem("alarmsViewed", "true");
                setUnreadCount(0);
                navigate("/alarms-notification");
              }}
            >
              <FaBell size={22} />
              {unreadCount > 0 && (
                <span className="alarm-badge">{unreadCount}</span>
              )}
            </div>

            {/* Profile Avatar Control */}
            <div className="profile-icon" onClick={() => navigate("/profile")}>
              <User size={20} />
            </div>
          </div>
        </div>

        {/* Scrollable Dashboard Frame Viewport */}
        <div className="page-wrapper">
          <Outlet />
        </div>

        {/* App Footer Context */}
        <footer className="app-footer">
          <p>© IgnisVigil 2026 Smart Fire Fighting Systems Monitoring Solution</p>
        </footer>
      </div>
    </div>
  );
};

export default Layout;